import React from "react";
import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";

const SCHOOLS = [
  { name: "Oklahoma State", q: "Oklahoma State", bg: "#FF7300", fg: "#0A0A0A" },
  { name: "Texas Longhorns", q: "Texas Longhorns", bg: "#BF5700", fg: "#FFFFFF" },
  { name: "Oklahoma Sooners", q: "Oklahoma Sooners", bg: "#841617", fg: "#FDF9F3" },
  { name: "TCU Horned Frogs", q: "TCU", bg: "#4D1979", fg: "#FFFFFF" },
  { name: "SMU Mustangs", q: "SMU", bg: "#C8102E", fg: "#FFFFFF" },
  { name: "Dallas Baptist", q: "Dallas Baptist", bg: "#1F8A4C", fg: "#FFFFFF" },
  { name: "Texas Woman's", q: "Texas Woman's", bg: "#862633", fg: "#FFFFFF" },
  { name: "Texas Tech", q: "Texas Tech", bg: "#CC0000", fg: "#0A0A0A" },
];

export const ShopBySchool = ({ embedded = false }) => (
  <section
    className={embedded ? "mb-10" : "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20"}
    data-testid="shop-by-school"
  >
    <div className="flex items-center gap-3 mb-8">
      <div className="w-11 h-11 rounded-xl bg-brand border-2 border-ink shadow-hard-sm flex items-center justify-center">
        <GraduationCap className="w-6 h-6 text-white" />
      </div>
      <h2 className="text-3xl sm:text-4xl font-black tracking-tight">Shop by School 🎓</h2>
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
      {SCHOOLS.map((s) => (
        <Link
          key={s.name}
          to={`/shop?category=Collegiate&q=${encodeURIComponent(s.q)}`}
          style={{ backgroundColor: s.bg, color: s.fg }}
          className="rounded-2xl border-2 border-ink shadow-hard px-4 py-6 font-black text-center leading-tight hover:shadow-hard-lg hover:-translate-y-1 transition-all"
          data-testid={`school-${s.q.toLowerCase().replace(/[^a-z]+/g, "-")}`}
        >
          {s.name}
        </Link>
      ))}
    </div>
  </section>
);
